import React from 'react'

export const TabAutomation: React.FC = () => {
    return <>TabAutomation</>
}
